import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function ActivityCards() {
  return <section className="w-full py-16 md:py-20" style={{
    backgroundColor: '#f8f6f0'
  }} aria-label="Club activities" data-id="element-34">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-35">
        <div className="text-center mb-12" data-id="element-36">
          <p className="text-xs font-bold uppercase tracking-widest mb-2" style={{
          color: '#c8a84b',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-37">
            Programs &amp; Sports
          </p>
          <h2 className="text-3xl md:text-4xl font-bold uppercase" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-38">
            Club Activities
          </h2>
          <div className="section-divider-center" data-id="element-39" />
          <p className="text-base max-w-2xl mx-auto" style={{
          color: '#5a5a5a',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-40">
            From competitive shooting sports to archery and education, FLSC
            offers something for every sportsman.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-id="element-41">
          {/* Sporting Clays */}
          <a href="/18.html" className="group relative rounded-2xl overflow-hidden block" style={{
          minHeight: '280px',
          boxShadow: '0 4px 16px rgba(0,0,0,0.12)'
        }} aria-label="Sporting Clays" data-id="element-42">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/Front%20Page/Steel%20Challenge%20Generic%2024.jpg" alt="Sporting Clays" className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-43" />
            <div className="absolute inset-0" style={{
            background: 'linear-gradient(to top, rgba(15,35,24,0.92) 0%, rgba(15,35,24,0.4) 60%, transparent 100%)'
          }} data-id="element-44" />
            <div className="absolute bottom-0 left-0 right-0 p-5" data-id="element-45">
              <h3 className="text-xl font-bold uppercase text-white mb-1" style={{
              fontFamily: 'Oswald, sans-serif'
            }} data-id="element-46">
                Sporting Clays
              </h3>
              <p className="text-xs mb-3" style={{
              color: '#a0c8b0',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-47">
                16-station course · Public weekends
              </p>
              <span className="inline-flex items-center gap-1 text-xs font-semibold" style={{
              color: '#c8a84b',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-48">
                Learn More <ArrowRightIcon size={12} data-id="element-49" />
              </span>
            </div>
          </a>

          {/* Cowboy Action Shooting */}
          <a href="/16.html" className="group relative rounded-2xl overflow-hidden block" style={{
          minHeight: '280px',
          boxShadow: '0 4px 16px rgba(0,0,0,0.12)'
        }} aria-label="Cowboy Action Shooting" data-id="element-50">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/CASS.jpg" alt="Cowboy Action Shooting" className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-51" />
            <div className="absolute inset-0" style={{
            background: 'linear-gradient(to top, rgba(15,35,24,0.92) 0%, rgba(15,35,24,0.4) 60%, transparent 100%)'
          }} data-id="element-52" />
            <div className="absolute bottom-0 left-0 right-0 p-5" data-id="element-53">
              <h3 className="text-xl font-bold uppercase text-white mb-1" style={{
              fontFamily: 'Oswald, sans-serif'
            }} data-id="element-54">
                Cowboy Action
              </h3>
              <p className="text-xs mb-3" style={{
              color: '#a0c8b0',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-55">
                SASS · Period-correct competition
              </p>
              <span className="inline-flex items-center gap-1 text-xs font-semibold" style={{
              color: '#c8a84b',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-56">
                Learn More <ArrowRightIcon size={12} data-id="element-57" />
              </span>
            </div>
          </a>

          {/* Jr. Rifle */}
          <a href="/15.html" className="group relative rounded-2xl overflow-hidden block" style={{
          minHeight: '280px',
          boxShadow: '0 4px 16px rgba(0,0,0,0.12)'
        }} aria-label="Jr. Rifle" data-id="element-58">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/Front%20Page/JR%20Rifle2.jpg" alt="Jr. Rifle Program" className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-59" />
            <div className="absolute inset-0" style={{
            background: 'linear-gradient(to top, rgba(15,35,24,0.92) 0%, rgba(15,35,24,0.4) 60%, transparent 100%)'
          }} data-id="element-60" />
            <div className="absolute bottom-0 left-0 right-0 p-5" data-id="element-61">
              <h3 className="text-xl font-bold uppercase text-white mb-1" style={{
              fontFamily: 'Oswald, sans-serif'
            }} data-id="element-62">
                Jr. Rifle
              </h3>
              <p className="text-xs mb-3" style={{
              color: '#a0c8b0',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-63">
                Ages 10–18 · Tuesday evenings
              </p>
              <span className="inline-flex items-center gap-1 text-xs font-semibold" style={{
              color: '#c8a84b',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-64">
                Learn More <ArrowRightIcon size={12} data-id="element-65" />
              </span>
            </div>
          </a>

          {/* Education & Training */}
          <a href="/67.html" className="group relative rounded-2xl overflow-hidden block" style={{
          minHeight: '280px',
          boxShadow: '0 4px 16px rgba(0,0,0,0.12)'
        }} aria-label="Education and Training" data-id="element-66">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/Front%20Page/Education-and-Training.gif" alt="Education and Training" className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-67" />
            <div className="absolute inset-0" style={{
            background: 'linear-gradient(to top, rgba(15,35,24,0.92) 0%, rgba(15,35,24,0.4) 60%, transparent 100%)'
          }} data-id="element-68" />
            <div className="absolute bottom-0 left-0 right-0 p-5" data-id="element-69">
              <h3 className="text-xl font-bold uppercase text-white mb-1" style={{
              fontFamily: 'Oswald, sans-serif'
            }} data-id="element-70">
                Education &amp; Safety
              </h3>
              <p className="text-xs mb-3" style={{
              color: '#a0c8b0',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-71">
                NRA Certified · Members &amp; public
              </p>
              <span className="inline-flex items-center gap-1 text-xs font-semibold" style={{
              color: '#c8a84b',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-72">
                Learn More <ArrowRightIcon size={12} data-id="element-73" />
              </span>
            </div>
          </a>
        </div>

        {/* Secondary activity links */}
        <div className="mt-8 flex flex-wrap justify-center gap-3" data-id="element-74">
          {[{
          label: 'Steel Challenge',
          href: '/56.html'
        }, {
          label: '3-D Archery',
          href: '/17.html'
        }, {
          label: 'PPC Shooting',
          href: '/19.html'
        }, {
          label: 'Bowling Pin Shoots',
          href: '/42.html'
        }].map(({
          label,
          href
        }) => <a key={href} href={href} className="px-5 py-2.5 rounded-full text-sm font-medium border transition-all hover:bg-forest hover:text-white" style={{
          borderColor: '#2d5a3d',
          color: '#2d5a3d',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-75">
              {label}
            </a>)}
        </div>
      </div>
    </section>;
}